import App from '../App.vue'
import Vuex from "vuex"
// import Setting from "./Setting/index"
import User from "./User/index"
import Paygw from "./Paygw/index"
import DeepLink from "./DeepLink/index"
import Country from "./Country/index"
import SaasOrgData from "./SaasOrgData"
import AppicationStaticConfig from './AppicationStaticConfig'
import QuizBotMsg from './QuizBotMsg'
import MicroAppPreference from './MicroAppPreference'

import { createApp } from 'vue'

let app = createApp(App)
app.use(Vuex)


const debug = process.env.NODE_ENV !== "prod"

export default new Vuex.Store({
  modules: {
    User,
    Paygw,
    DeepLink,
    SaasOrgData,
    Country,
    AppicationStaticConfig,
    QuizBotMsg,
    MicroAppPreference
  },
  strict: debug
})
